import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { Container as AdsContainer } from "scmp-app/components/advertisement/ad-slots/ad-slot/styles";

import { Container as ArticleContainer } from "./feed-view-article/styles";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-block-start: 32px;
  margin-inline: auto;
  padding-inline: 20px;

  ${theme.breakpoints.up("tablet")} {
    padding-inline: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    display: grid;
    grid:
      "articles right-content" min-content
      "articles ." min-content
      "articles ads" 1fr
      / 1fr 320px;
    gap: 0 52px;

    max-inline-size: 1024px;
    padding-inline: 0;
  }
`;

export const ArticleList = styled.div`
  grid-area: articles;

  max-inline-size: 480px;
  margin-block-end: 64px;
  margin-inline: auto;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 704px;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 1024px;
  }

  ${ArticleContainer} {
    &:last-of-type {
      margin-block-end: 0;
      padding-block-end: 0;
      border-block-end: none;
    }
  }
`;

export const DesktopContainer = styled.div`
  grid-area: right-content;

  display: none;

  inline-size: 320px;
  margin-block-end: 48px;

  ${theme.breakpoints.up("desktop")} {
    display: flex;
    flex-direction: column;
    gap: 48px;
  }
`;

export const MobileContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 48px;
  align-items: center;

  margin-block: 32px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;

    margin-block: 48px;
  }

  ${theme.breakpoints.up("desktop")} {
    display: none;
  }
`;

type BlockProps = {
  $backgroundColor: string;
};
export const Block = styled.div<BlockProps>`
  inline-size: 320px;
  block-size: 400px;

  background-color: ${props => props.$backgroundColor};
`;

export const AdsSlotContainer = styled.div`
  ${AdsContainer} {
    justify-content: flex-start;

    block-size: auto;
  }
`;

export const SecondaryAdsSlotContainer = styled.div`
  grid-area: ads;

  margin-block-end: 64px;

  ${AdsContainer} {
    justify-content: flex-start;
  }
`;

export const MobileAdsContainer = styled.div``;
export const TabletAdsContainer = styled.div`
  display: none;

  ${theme.breakpoints.only("tablet")} {
    display: block;
  }
`;
